import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@companion-core/shared/app/Components/Button";
import { redirectTo } from "Utilities/navigation";

import "@companion-core/web/src/Assets/Styles/scss/errors.scss";

export const FrameBusted = () => {
  const { t } = useTranslation();

  return (
    <div className="error__framebusted">
      <span className="super-title-1">{t("common.error.clickjacking.title")}</span>
      <span className="body-text-2 error__framebusted-subtitle">
        {t("common.error.clickjacking.subtitle")}
      </span>
      <Button
        label={t("common.error.clickjacking.cta")}
        classNames={["error__framebusted-cta"]}
        testID="error__framebusted-cta"
        size="large"
        onClick={() => redirectTo(window.self.location.href, "external", undefined, "_self")}
      />
    </div>
  );
};
